module.exports = __webpack_public_path__ + "assets/img/prize_3.af53cd8d.png";